import React from 'react'
import ParentStyles from '../../styles'
import { MODULES_DATA } from '~/constants/tutorialModules'
import styled from 'styled-components'
import useAxios from 'axios-hooks'
import { FormattedMessage, useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import { Codesandbox } from 'react-feather'
import { lowerCase } from 'lodash'
import { Spinner } from 'reactstrap'

export default function FAQSection() {
  const intl = useIntl()
  const [{ loading, error, data }] = useAxios({
    url: '/tutorial/hub',
    method: 'GET',
  })

  React.useEffect(() => {
    if (!error) return
    toast.error(intl.formatMessage({ id: 'Failed to fetch tutorials' }))
  }, [error])
  return (
    <ParentStyles.Box>
      <ParentStyles.Title>
        <FormattedMessage id="Help Center" />
      </ParentStyles.Title>
      <CardsWrapper>
        {loading && (
          <Spinner
            style={{
              alignSelf: 'center',
            }}
          />
        )}
        {data?.modules?.map(module => (
          <Card key={module} href={`/tutorial/module/${lowerCase(module)}`}>
            <div className="module-icon">
              {MODULES_DATA[module]?.icon ? (
                MODULES_DATA[module].icon
              ) : (
                <Codesandbox color="#fff" />
              )}
            </div>
            <div className="module-title">
              <FormattedMessage id={MODULES_DATA[module]?.name || 'Module'} />
            </div>
          </Card>
        ))}
      </CardsWrapper>
    </ParentStyles.Box>
  )
}

const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`

const Card = styled.a`
  display: flex;
  height: 80px;
  padding: 16px 24px 16px 16px;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));
  background: #fff;
  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: 0px 2px 6px 0px rgba(115, 103, 240, 0.3);
  }

  .module-icon {
    display: flex;
    width: 48px;
    height: 48px;
    padding: 8px;
    justify-content: center;
    align-items: center;
    gap: var(--Gap-gap-2, 8px);
    border-radius: 6px;
    background: var(
      --menu-active,
      linear-gradient(270deg, rgba(115, 103, 240, 0.7) 0%, #7367f0 100%)
    );

    box-shadow: 0px 2px 6px 0px rgba(115, 103, 240, 0.3);
  }

  .module-title {
    color: #2f2b3d;
    opacity: 0.9;
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
  }
`
